<!-- Subtotal -->
<div *ngIf="{ value: subtotal$ | async } as subtotal">
  <label>Subtotal</label>
  <p data-cy="side-bar-subtotal-amount">
    {{ subtotal.value == undefined ? '--' : (subtotal.value | currency: currency().code) }}
  </p>
</div>

<!-- Late fees -->
<ng-container
  *ngIf="{
    disableLateFeesMessage: disableLateFeesMessage(),
    ignoreLateFees: ignoreLateFees$ | async,
    lateFeesExist: lateFeesExist$ | async,
    lateFeesTotal: lateFeesTotal$ | async,
    payLateFees: payAllLateFees$ | async
  } as data"
>
  <ng-container *ngIf="data.lateFeesTotal && (!data.ignoreLateFees || !!data.disableLateFeesMessage)">
    <div>
      <div class="d-flex align-items-center">
        <label [ngClass]="{ 'strike-through': !data.payLateFees || !!data.disableLateFeesMessage }">
          {{ lateFeeLabel$ | async | labelCase }}
        </label>

        <aiwyn-icon *ngIf="lateFeeTooltipMessage() as lateFeeTooltip" name="info" size="small" class="ms-1" [tooltip]="lateFeeTooltip">
        </aiwyn-icon>

        <ng-container *ngIf="!areLateFeesByClient() && !data.disableLateFeesMessage && !configService.paymentLateFeeRequired">
          &nbsp;(
          <button
            andButton
            color="hyperlink"
            class="p-0"
            (click)="setPayLateFees(!data.payLateFees)"
            [attr.data-cy]="data.payLateFees ? 'remove-finance-charges' : 'add-finance-charge'"
          >
            {{ data.payLateFees ? 'Remove' : 'Add' }}
          </button>
          )
        </ng-container>
      </div>

      <p
        [ngClass]="{ 'strike-through': !data.payLateFees || !!data.disableLateFeesMessage }"
        class="color-red-300"
        data-cy="side-bar-finance-charge-amount"
      >
        {{ '+' + (data.lateFeesTotal | currency) }}
      </p>
    </div>

    <p class="w-100 small-300" *ngIf="!data.payLateFees || !!data.disableLateFeesMessage">
      {{ data.disableLateFeesMessage ?? '' }}
      Note that you are still responsible for {{ (payLateFeesByClient$ | async) ? 'these' : 'this' }}
      {{ lateFeeLabel$ | async | lowercase }}.
    </p>
  </ng-container>
</ng-container>

<!-- Processing fees -->
<div *ngIf="!(isCustomProcessingFeeEnabled && authAdaptor.isAdmin); else editableProcessingFeeTemplate">
  <ng-container *ngIf="{ amount: processingFee$ | async, rate: processingFeeRate$ | async } as processingFee">
    <div class="d-flex align-items-center">
      <label data-cy="processing-fee-label">
        {{ !processingFee.amount ? '' : (processingFee.rate | percent : '1.0-2') + ' ' }}{{ configService.processingFeeLabel }}
      </label>
      <aiwyn-icon
        *ngIf="processingFee.amount > 0"
        name="info"
        size="small"
        class="ms-1"
        data-cy="processing-fee-tooltip"
        [tooltip]="buildProcessingFeeTooltip(processingFee.rate | percent : '1.0-2')"
      ></aiwyn-icon>
    </div>

    <p>{{ processingFee.amount == undefined ? '--' : (processingFee.amount | currency: currency().code) }}</p>
  </ng-container>
</div>

<ng-template #editableProcessingFeeTemplate>
  <div>
    <div class="d-flex align-items-center color-gray-300">
      <span data-cy="processing-fee-label">{{ configService.processingFeeLabel }}</span>
      <input
        [formControl]="customProcessingFeeRateControl"
        class="form-input form-input--percent ms-1 custom-processing-fee-rate"
        numberOnly
        exceptions="."
        [maxDecimalPlaces]="2"
        maxlength="5"
        [ngClass]="{ 'form-input--invalid' : customProcessingFeeRateControl.invalid && (customProcessingFeeRateControl.dirty || customProcessingFeeRateControl.touched) }"
        data-cy="custom-processing-fee-rate-input"
      >
    </div>

    <input
      [formControl]="customProcessingFeeControl"
      class="form-input custom-processing-fee"
      currencyMask
      maxlength="11"
      [options]="{ prefix: currency().symbol, align: 'right', allowNegative: 'false' }"
      [ngClass]="{ 'form-input--invalid' : customProcessingFeeControl.invalid && (customProcessingFeeControl.dirty || customProcessingFeeControl.touched) }"
      data-cy="custom-processing-fee-input"
    >
  </div>
</ng-template>

<!-- International fees -->
<div *ngIf="internationalFee$ | async as internationalFee">
  <div class="d-flex align-items-center">
    <label>{{ internationalFeeRate$ | async | percent : '1.0-2' }} International fee</label>
    <aiwyn-icon
      name="info"
      size="small"
      class="ms-1"
      [tooltip]="internationalFeeRateTooltipMessage$ | async"
    ></aiwyn-icon>
  </div>

  <p data-cy="side-bar-international-fee-amount">{{ internationalFee | currency: currency().code }}</p>
</div>

<!-- Total -->
<div *ngIf="{ value: total$ | async } as total">
  <div class="d-flex align-items-center">
    <p class="color-gray-100 body-600">Total</p>
    <p *ngIf="!(forceZeroState$ | async) && (selectedPaymentMethod$ | async) == undefined" class="body-300 ms-1 color-gray-300">
      (select payment method)
    </p>
  </div>
  <!-- These dashes are built different. -->
  <p class="h3-500 lh-1" data-cy="side-bar-total-amount">
    {{ total.value == undefined ? '– –' : (total.value | currency: currency().code) }}
  </p>
</div>
